import api from "../../components/services/api";
import { useParams } from "react-router";
import { useState } from "react";
import { useEffect } from "react";
import moment from "moment";
import "./SaleOrder.css";
export default function ContainerList() {
  let { id } = useParams();
  const [data, setData] = useState();
  const [container, setContainer] = useState([]);
  const [transportation, setTransportation] = useState();
  const [locationData, setLocationData] = useState([]);
  const getContainer = async () => {
    const res = await api(`api/saleorder/detail/container/${id}`);
    const data = await res.data;
    setContainer(data);
  };
  const getData = async () => {
    const res = await api(`api/saleorder/detail/bookinginfo/${id}`);
    const data = await res.data;
    setData(data);
  };
  const getTransportation = async () => {
    const res = await api(`api/saleorder/detail/transportation/${id}`);
    const data = await res.data;
    setTransportation(data);
  };
  const getLocation = async () => {
    try {
      const res = await api.get("api/location/list");
      const data = await res.data
      if (res.meta.status === true) {
        setLocationData(data);
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getData();
    getContainer()
    getTransportation()
    getLocation()
  }, []);


  const pageCount = Math.ceil(container?.length / 10)
  const rows = [];
  for (let pageIndex = 0; pageIndex < pageCount; pageIndex++) {
    rows.push(<>
      <page>
        <div class="header">
          <img src="/images/logo2.png" class="logo" />
          <div className="header_title">
            <h3>SRITRANG LOGISTIC COMPANY LIMITED</h3>
            <h5>บริษัท ศรีตรังโลจิสติกส์ จำกัด </h5>
          </div>
        </div>
        <div class="titleR">
          <h3>Container List</h3>
        </div>
        <div class="content">
          <div className="rowR">
            <p className="header_p">Sale Order No. </p>
            <p> {data?.SaleOrderNo || '-'}</p>
          </div>
          <div className="rowR">

          </div>
          <div className="rowR">
            <p className="header_p">Shipper Ref No.</p>
            <p> {data?.ShipperRefNo || '-'}</p>
          </div>
          <div className="rowR">

          </div>
          <div className="rowR">
            <p className="header_p">Booking No.</p>
            <p> {data?.BookingNo || '-'}</p>
          </div>
          <div className="rowR">

          </div>
          <div class="rowR sub">
            <p className="header_p">Quantity </p>
            <p>{transportation?.Quantity || '-'} </p>
          </div>
          <div class="rowR sub">
            <p className="header_p">Size </p>
            <p> {data?.Size || '-'}</p>
          </div>
          <div className="rowR">

          </div>
          <div className="rowR">
            <p className="header_p">Gender </p>
            <p>{transportation?.InboundContainerGender || '-'}</p>
          </div>
          <div className="rowR">

          </div>
          <div style={{ marginBottom: '30px' }}></div>
          <div className="rowR">
            <p className="header_p">Port of Loading </p>
            <p>{locationData?.find((x) => x?.LocationId === transportation?.InboundGateOutId)?.LocationName || '-'} </p>
          </div>
          <div className="rowR">
            <p className="header_p">ETD </p>
            <p>{transportation?.InboundETDGateOut ? moment(transportation?.InboundETDGateOut).format('DD/MM/YYYY') : '-'} </p>
          </div>

          <div class="rowR">
            <p className="header_p">Port of Discharge </p>
            <p> {locationData?.find((x) => x?.LocationId === transportation?.OutboundGateOutId)?.LocationName || '-'}</p>
          </div>
          <div class="rowR">
            <p className="header_p">ETA</p>
            <p> {transportation?.InboundETAGateIn ? moment(transportation?.InboundETAGateIn).format('DD/MM/YYYY') : '-'}</p>
          </div>

          <div class="rowR">
            <p className="header_p">VOY IN </p>
            <p> {data?.InboundVoyNo || '-'}</p>
          </div>
          <div class="rowR"></div>
        </div>
        <div class="content_center" style={{ 
          // marginTop: "-10px"
           }}>
          <div class="rowR first" style={{ flexBasis: '40%' }}>
            <p className="header_p" >Container Status </p>
            <p>{transportation?.ContainerStockType || '-'}</p>
          </div>
          <div class="rowR">
            <p className="header_p">Grade</p>
            <p>{transportation?.ContainerGrade || '-'}</p>
          </div>
          <div class="rowR">
            <p className="header_p">Plastic Sheet</p>
            <p>
              {transportation?.ContainerApplyPlasticSheet ? 'yes' : 'no'}
            </p>
          </div>
          <div class="rowR first"></div>

        </div>
        <div class="content">
          <div className="rowR">
            <p className="header_p">Stuffing Plan </p>
            <p></p>
          </div>
          <div className="rowR">

          </div>
          <div className="rowR">
            <p className="header_p">Pick-up Date </p>
            <div style={{ display: "flex" }}>
              {data?.StuffingPlan?.map((x, i) => (
                <p>{x?.PickupDate}</p>
              ))}
            </div>
          </div>
          <div className="rowR">

          </div>
          <div className="rowR">
            <p className="header_p">Factory </p>
            <div style={{ display: "flex" }}>
              {data?.StuffingPlan?.map((x, i) => (
                <p>{x?.FactoryName}</p>
              ))}
            </div>
          </div>
          <div className="rowR">

          </div>
          <div className="rowR">
            <p className="header_p">Return Date </p>
            <div style={{ display: "flex" }}>
              {data?.StuffingPlan?.map((x, i) => (
                <p>{x?.ReturnDate}</p>
              ))}
            </div>
          </div>
          <div className="rowR">

          </div>
        </div>
        <div class="content">
          <div class="rowR">
            <p className="header_p" style={{ flexBasis: '50%' }}>Booking Information</p>
            <p></p>
          </div>
          <div className="rowR">

          </div>
          <div class="rowR">
            <p className="header_p">Port of Loading</p>
            <p>{locationData?.find((x) => x?.LocationId === data?.POLLocationId)?.LocationName || '-'}</p>
          </div>
          <div class="rowR">
            <p className="header_p">ETD</p>
            <p>
             {data?.ETDPOLDate ? moment(data?.ETDPOLDate).format('DD/MM/YYYY') : '-'}
            </p>
          </div>
          <div class="rowR">
            <p className="header_p">Port of Discharge</p>
            <p>{locationData?.find((x) => x?.LocationId === data?.PODLocationId)?.LocationName || '-'}</p>
          </div>
          <div class="rowR">
            <p className="header_p">ETA</p>
            <p>
             {data?.ETAPODDate ? moment(data?.ETAPODDate).format('DD/MM/YYYY') : '-'}
            </p>
          </div>
          <div class="rowR">
            <p className="header_p">Vessle</p>
            <p>{data?.FeederVessel} {data?.MotherVessel} {data?.ThirdVessel}</p>
          </div>
        </div>

        <div class="containerR">

          <table border="1" cellpadding="10" cellspacing="0">
            <tr style={{ border: "1px solid" }}>
              <th style={{ border: "1px solid" }}>No.</th>
              <th style={{ border: "1px solid" }}>Container Number</th>
              <th style={{ border: "1px solid" }}>Seal Shipper</th>
              <th style={{ border: "1px solid" }}>Tare Weight</th>
              <th style={{ border: "1px solid" }}>Remark</th>

            </tr>

            <tr
              style={{
                border: "1px solid",
                fontSize: "16px",
                height: "27px",
              }}
            >
              <td style={{ border: "1px solid" }}>{(pageIndex * 10) + 1}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]?.ContainerNo}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]?.SealShipper}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]?.ContainerTareWeight?.toLocaleString()}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]?.Remark}</td>
            </tr>
            <tr
              style={{
                border: "1px solid",
                fontSize: "16px",
                height: "27px",
              }}
            >
              <td style={{ border: "1px solid" }}>{(pageIndex * 10) + 2}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[1]?.ContainerNo}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[1]?.SealShipper}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[1]?.ContainerTareWeight?.toLocaleString()}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[1]?.Remark}</td>
            </tr>
            <tr
              style={{
                border: "1px solid",
                fontSize: "16px",
                height: "27px",
              }}
            >
              <td style={{ border: "1px solid" }}>{(pageIndex * 10) + 3}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[2]?.ContainerNo}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[2]?.SealShipper}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[2]?.ContainerTareWeight?.toLocaleString()}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[2]?.Remark}</td>
            </tr>
            <tr
              style={{
                border: "1px solid",
                fontSize: "16px",
                height: "27px",
              }}
            >
              <td style={{ border: "1px solid" }}>{(pageIndex * 10) + 4}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[3]?.ContainerNo}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[3]?.SealShipper}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[3]?.ContainerTareWeight?.toLocaleString()}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[3]?.Remark}</td>
            </tr>
            <tr
              style={{
                border: "1px solid",
                fontSize: "16px",
                height: "27px",
              }}
            >
              <td style={{ border: "1px solid" }}>{(pageIndex * 10) + 5}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[4]?.ContainerNo}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[4]?.SealShipper}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[4]?.ContainerTareWeight?.toLocaleString()}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[4]?.Remark}</td>
            </tr>
            <tr
              style={{
                border: "1px solid",
                fontSize: "16px",
                height: "27px",
              }}
            >
              <td style={{ border: "1px solid" }}>{(pageIndex * 10) + 6}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[5]?.ContainerNo}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[5]?.SealShipper}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[5]?.ContainerTareWeight?.toLocaleString()}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[5]?.Remark}</td>
            </tr>
            <tr
              style={{
                border: "1px solid",
                fontSize: "16px",
                height: "27px",
              }}
            >
              <td style={{ border: "1px solid" }}>{(pageIndex * 10) + 7}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[6]?.ContainerNo}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[6]?.SealShipper}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[6]?.ContainerTareWeight?.toLocaleString()}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[6]?.Remark}</td>
            </tr>

            <tr
              style={{
                border: "1px solid",
                fontSize: "16px",
                height: "27px",
              }}
            >
              <td style={{ border: "1px solid" }}>{(pageIndex * 10) + 8}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[7]?.ContainerNo}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[7]?.SealShipper}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[7]?.ContainerTareWeight?.toLocaleString()}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[7]?.Remark}</td>
            </tr>
            <tr
              style={{
                border: "1px solid",
                fontSize: "16px",
                height: "27px",
              }}
            >
              <td style={{ border: "1px solid" }}>{(pageIndex * 10) + 9}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[8]?.ContainerNo}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[8]?.SealShipper}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[8]?.ContainerTareWeight?.toLocaleString()}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[8]?.Remark}</td>
            </tr>
            <tr
              style={{
                border: "1px solid",
                fontSize: "16px",
                height: "27px",
              }}
            >
              <td style={{ border: "1px solid" }}>{(pageIndex * 10) + 10}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[9]?.ContainerNo}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[9]?.SealShipper}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[9]?.ContainerTareWeight?.toLocaleString()}</td>
              <td style={{ border: "1px solid" }}>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[9]?.Remark}</td>
            </tr>



          </table>
        </div>

      </page>
    </>
    )
  }
  return (

    <>
      {rows}
    </>

  );
}
